import { render, staticRenderFns } from "./CertificationsManager.vue?vue&type=template&id=c8f981d4&scoped=true"
import script from "./CertificationsManager.vue?vue&type=script&lang=js"
export * from "./CertificationsManager.vue?vue&type=script&lang=js"
import style0 from "./CertificationsManager.vue?vue&type=style&index=0&id=c8f981d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f981d4",
  null
  
)

export default component.exports